export const hiddenPosition = { left: -500, top: -500 };
export const computePosition = (currentOuter?: HTMLElement) => {
  const current = currentOuter || {
    innerHeight: 0,
    innerWidth: 0,
    offsetHeight: 0,
    offsetWidth: 0,
  };

  const domSelection = window.getSelection();

  if (!current || !domSelection || domSelection.rangeCount <= 0) {
    return hiddenPosition;
  }

  const domRange = domSelection.getRangeAt(0);
  const rect = domRange.getBoundingClientRect();

  let left = Math.max(
    rect.left + window.pageXOffset - current.offsetWidth / 2 + rect.width / 2,
    0,
  );

  if (left + current.offsetWidth > window.innerWidth) {
    left = window.innerWidth - current.offsetWidth;
  }

  const lowerMost =
    Math.min(window.scrollY, rect.bottom + window.pageYOffset) + 10;

  const top = Math.max(
    rect.top + window.pageYOffset - current.offsetHeight - 10,
    10,
    lowerMost,
  );

  return {
    left,
    top,
  };
};
